import { Tooltip } from "antd"
import cls from "classnames"

import { HIGHLIGHTED_RISK_LEVELS } from "../riskLevel"

import styles from "./RiskPill.module.less"

const RiskPill = ({ level, tooltip, children }) => {
  if (!HIGHLIGHTED_RISK_LEVELS.includes(level)) return children

  const pill = <span className={cls(styles.pill, styles[level])}>{children}</span>

  return tooltip ? <Tooltip title={tooltip}>{pill}</Tooltip> : pill
}

export default RiskPill
